import styled from 'styled-components'

const AboutSectionStyle = styled.div`
	--iconSize: var(--sp13x);

	margin-top: var(--sectionMargin);

	.ng-avatar1 {
		display: inline-block;
		width: 8.1%;
		padding-top: 8.1%;
		margin-right: var(--sp5x);
	}

	.ng-avatar2 {
		display: inline-block;
		width: 5.8%;
		padding-top: 5.6%;
		margin-top: -100%;
		margin-bottom: -1%;
	}

	.iconsWrap {
		display: inline-block;
		overflow: hidden;
		position: relative;
		margin-top: -100%;
		margin-bottom: -2%;

		svg {
			transition: var(--trTime2);
			display: inline-block;
			width: var(--iconSize);
			height: var(--iconSize);
			margin: 0 var(--sp2x);
			fill: var(--cream);
		}

		.icon-cherry {
			transition-delay: 100ms;
			margin-left: var(--sp4x);
		}

		.icon-lemon {
			transition-delay: 200ms;
		}

		.icon-clover {
			transition-delay: 300ms;
		}

		.icon-horse-shoe {
			transition-delay: 400ms;
			margin-right: var(--sp4x);
		}

		@media (hover: hover) {
			&:hover {
				svg {
					transform: translateY(170%);
				}
			}
		}

		.iconsClone {
			display: inline-flex;
			position: absolute;
			bottom: 155%;
			left: 0;
		}
	}
	.coinWrap {
		display: inline-block;
		margin: 0 var(--sp3x);
		.icon-coin {
			display: inline-block;
			width: var(--iconSize);
			height: var(--iconSize);
			transition: var(--trTime2);
			margin-top: -100%;
			fill: var(--cream);

			@media (hover: hover) {
				&:hover {
					transform: rotate(30deg);
				}
			}
		}
	}
	.lottieMainWrap {
		display: inline-block;
		max-width: var(--sp27x);
		width: 100%;
		margin-top: -100%;
		position: relative;
		height: var(--sp6x);

		.LottieWrap {
			display: inline-flex;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 100%;
			margin: 0 var(--sp2x);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		--iconSize: var(--sp10x);

		.ng-avatar1 {
			width: 10.1%;
			padding-top: 10.1%;
			margin-right: var(--sp2x);
		}

		.ng-avatar2 {
			width: 6.6%;
			padding-top: 6.4%;
			margin-bottom: -1.2%;
		}

		.iconsWrap {
			margin-bottom: -2%;

			svg {
				margin: 0 var(--sp2x);
			}

			.icon-cherry {
				margin-left: var(--sp4x);
			}

			.icon-horse-shoe {
				margin-right: var(--sp4x);
			}
		}
		.coinWrap {
			.icon-coin {
				margin-top: -100%;
				margin-bottom: -1%;
			}
		}

		.lottieMainWrap {
			max-width: var(--sp19x);
			height: var(--sp6x);

			.LottieWrap {
				margin: 0 var(--sp2x);
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		--iconSize: var(--sp8x);

		.aboutText {
			line-height: 1.5;
		}

		.ng-avatar1 {
			width: 10.8%;
			padding-top: 10.8%;
			margin-right: var(--sp4x);
		}

		.ng-avatar2 {
			width: 7.1%;
			padding-top: 7%;
			margin-bottom: -1.2%;
		}

		.iconsWrap {
			margin-bottom: -2%;

			svg {
				margin: 0 var(--sp1-5x);
			}

			.icon-cherry {
				margin-left: var(--sp3x);
			}

			.icon-horse-shoe {
				margin-right: var(--sp3x);
			}
		}

		.coinWrap {
			.icon-coin {
				margin-top: -100%;
				margin-bottom: -1%;
			}
		}

		.lottieMainWrap {
			max-width: var(--sp16x);
			height: var(--sp6x);

			.LottieWrap {
				margin: 0 var(--sp2x);
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		--iconSize: var(--sp6x);

		.ng-avatar1 {
			width: 10.6%;
			padding-top: 10.6%;
			margin-right: var(--sp2x);
		}

		.ng-avatar2 {
			width: 6.8%;
			padding-top: 6.6%;
			margin-bottom: -1.2%;
		}

		.iconsWrap {
			margin-bottom: -2%;

			svg {
				margin: 0 var(--sp1-5x);
			}

			.icon-cherry {
				margin-left: var(--spSize);
			}

			.icon-horse-shoe {
				margin-right: var(--sp3x);
			}
		}
		.coinWrap {
			.icon-coin {
				margin-top: -100%;
				margin-bottom: -1%;
			}
		}
		.lottieMainWrap {
			max-width: var(--sp13x);
			height: var(--sp4x);

			.LottieWrap {
				margin: 0 var(--sp2x);
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		--iconSize: var(--sp6x);

		.ng-avatar1 {
			width: 14.2%;
			padding-top: 14.2%;
			margin-right: var(--sp2x);
		}

		.ng-avatar2 {
			max-width: var(--sp9x);
			width: 100%;
			padding-top: var(--sp9x);
			margin-bottom: -1.2%;
		}

		.iconsWrap {
			margin-bottom: -3%;

			svg {
				margin: 0 var(--sp1-5x);
			}

			.icon-cherry {
				margin-left: var(--sp3x);
			}

			.icon-horse-shoe {
				margin-right: var(--sp3x);
			}
		}

		.coinWrap {
			.icon-coin {
				margin-top: -100%;
			}
		}
		.lottieMainWrap {
			max-width: var(--sp12x);
			height: var(--sp4x);

			.LottieWrap {
				margin: 0 var(--sp2x);
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		--iconSize: var(--sp4x);

		.ng-avatar1 {
			width: 21.4%;
			padding-top: 21.4%;
			margin-right: var(--sp2x);
		}

		.ng-avatar2 {
			max-width: var(--sp8x);
			width: 100%;
			padding-top: var(--sp7x);
			margin-bottom: -3.6%;
		}

		.iconsWrap {
			margin-bottom: -3%;

			svg {
				margin: 0 var(--spSize);
			}

			.icon-cherry {
				margin-left: var(--sp2x);
			}

			.icon-horse-shoe {
				margin-right: var(--sp2x);
			}
		}
		.coinWrap {
			.icon-coin {
				margin-top: -100%;
			}
		}

		.lottieMainWrap {
			max-width: var(--sp10x);
			height: var(--sp2-5x);

			.LottieWrap {
				margin: 0 var(--spSize);
			}
		}
	}
`

export default AboutSectionStyle
